import { ShiftRecurrence } from "./generated/ModulesAPIClient";

export function patchShiftRecurrence(): void {
  const SR: any = ShiftRecurrence as any;
  if (!SR || SR.__patched) {
    return;
  }

  const fromJS = function (data: any): any {
    data = typeof data === "object" ? data : {};
    return new SR(data);
  };

  const toJSON = function (this: any, data?: any) {
    const out: any = data && typeof data === "object" ? { ...data } : {};
    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v !== undefined) {
        out[k] = v;
      }
    }
    return out;
  };

  SR.fromJS = fromJS;
  SR.prototype.toJSON = toJSON;
  SR.__patched = true;
}
